import { commonFilter } from './filter';

const pageId = '24011';

export default {
  pageName: 'Trending Publications',
  pageId,
  pagePath: '/opinion/Overview/TrendingPublications',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    TP_Tab: {
      buttonId: '2401101',
    },
    TP_Translate: {
      buttonId: '2401102',
    },
    TPTV_Sort: {
      buttonId: '2401107',
    },
    TPTV_ClickCard: {
      buttonId: '2401108',
    },
    TPTV_GoToUrl: {
      buttonId: '2401109',
    },
    TPTV_ClickMore: {
      buttonId: '2401113',
    },

    TPTP_Sort: {
      buttonId: '2401205',
    },
    TPTP_ClickCard: {
      buttonId: '2401206',
    },
    TPTP_GoToURL: {
      buttonId: '2401207',
    },
    TPTP_ClickDetails: {
      buttonId: '2401208',
    },
    TPTP_ClickCopy: {
      buttonId: '2401209',
    },
    ...commonFilter,
  },
  card: {
    TrendingVideos: {
      title: {
        buttonId: '2401103',
      },
      card: {
        buttonId: '2401104',
      },
      table: {
        buttonId: '2401105',
      },
      download: {
        buttonId: '2401106',
      },
    },
    TrendingPosts: {
      title: {
        buttonId: '2401201',
      },
      card: {
        buttonId: '2401202',
      },
      table: {
        buttonId: '2401203',
      },
      download: {
        buttonId: '2401204',
      },
    },
  },
  table: {
    TrendingVideos: {
      Sort: {
        buttonId: '2401112',
      },
      ClickCard: {
        buttonId: '2401110',
      },
      GoToURL: {
        buttonId: '2401111',
      },
    },
    TrendingPosts: {
      Sort: {
        buttonId: '2401208',
      },
      CopyReview: {
        buttonId: '2401211',
      },
      ViewDetails: {
        buttonId: '2401209',
      },
      GoToURL: {
        buttonId: '2401210',
      },
    },
  },
};
